import React from "react";
import { useNavigate } from "react-router-dom";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";

import { MdBarChart, MdDashboard } from "react-icons/md";
import Widget from "components/widget/Widget";
import { useAuth } from "context/AuthProvider";

import { urls } from "helpers/urls";
import { useFetch } from "hooks/useFetch";
import MostAskQuestion from "./components/MostAskQuestion";
import ChatRatio from "./components/ChatRatio";

const Dashboard = () => {
  const navigate = useNavigate();
  const { currentSub, retrieveToken, plan, counts, userLog, } = useAuth();


const {data,loading,error} = useFetch({
    url: urls.dashboard,
})
console.log(data)


  const totalAvailableCredits = currentSub.reduce(
    (accumulator, item) =>
      accumulator + (item.total_count - item.consumed_count),
    0
  );

  const totalCredits = currentSub.reduce(
    (accumulator, item) => accumulator + item.total_count,
    0
  );

  // Create a mapping of plan_id to plan data for efficient lookups
  const planIdToPlanData = {};
  plan.forEach((planItem) => {
    planIdToPlanData[planItem.id] = planItem;
  });


  // Map each subscription item to its corresponding plan

  const matchingPlans = currentSub.map(
    (items) => planIdToPlanData[items.plan_id]
  );

  const uniqueMatchingPlans = matchingPlans.map((item) => item.plan_name);
  const matchingPlansDetail = uniqueMatchingPlans.join(", ");

  const uniqueMatchingPlans_1 = [
    ...new Set(matchingPlans.map((item) => item.plan_name)),
  ];
  const matchingPlansDetail_1 = uniqueMatchingPlans_1.join(", ");

  return (
    <div>
      {/* Card widget */}

      <h1 className="text-[30px] font-bold font-figtree" style={{ fontFamily: "figtree" }}>Dashboard</h1>

      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Chat completion"}
          subtitle={data?.data?.upcoming_plans_total_count}
        />

        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Remaining chat completion"}
          subtitle={
            data?.data
              ? data.data.upcoming_plans_total_count - data.data.consumed_count
              : "0"
          }
        />

        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Questions Answered"}
          subtitle={data?.data?.consumed_count}
        />
      </div>

      {/* Charts */}

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
      <MostAskQuestion />
      <ChatRatio />
      </div>

    </div>
  );
};

export default Dashboard;
